import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import {connectToJSContext} from "../utils.jsx";

// for some reason webpack won't resolve when going up directories
import Footer from "../footer/index.jsx";
import Navigation from "../navigation/index.jsx";
import ProductList from "../product_list/index.jsx";
import {ProductsOrgCustomContent, ProductsUserCustomContent} from "../custom_content/index.jsx";
import {ProductsHero} from "../hero/index.jsx";
import ContactForm from "../contact_form/index.jsx";
import { PRODUCT_PAGE } from '../constants';

const ProductsPage = ({ showOrgCustomContent, showUserCustomContent, moduleOrder }) => {
    const componentMap = {
        [PRODUCT_PAGE.MODULES.PRODUCTS_HERO]: ProductsHero,
        [PRODUCT_PAGE.MODULES.PRODUCTS_ORG_CUSTOM_CONTENT]: showOrgCustomContent && ProductsOrgCustomContent,
        [PRODUCT_PAGE.MODULES.PRODUCTS_USER_CUSTOM_CONTENT]: showUserCustomContent && ProductsUserCustomContent,
        [PRODUCT_PAGE.MODULES.PRODUCT_LIST]: ProductList,
        [PRODUCT_PAGE.MODULES.CONTACT_FORM]: ContactForm
    };
    return (
        <div>
            <Navigation currentPage={'products'}/>
            <div id="maincontent" role="main">
                {moduleOrder.map((moduleName, i) => {
                    const Component = componentMap[moduleName];
                    return Component && <Component key={i} />;
                })}
            </div>
            <Footer />
        </div>
    );
};

ProductsPage.defaultProps = {
    moduleOrder: [
        PRODUCT_PAGE.MODULES.PRODUCTS_HERO,
        PRODUCT_PAGE.MODULES.PRODUCTS_ORG_CUSTOM_CONTENT,
        PRODUCT_PAGE.MODULES.PRODUCTS_USER_CUSTOM_CONTENT,
        PRODUCT_PAGE.MODULES.CONTACT_FORM,
        PRODUCT_PAGE.MODULES.PRODUCT_LIST
    ]
};

ProductsPage.propTypes = {
    showOrgCustomContent: PropTypes.bool.isRequired,
    showUserCustomContent: PropTypes.bool.isRequired,
    moduleOrder: PropTypes.arrayOf(
        PropTypes.oneOf(_.values(PRODUCT_PAGE.MODULES))
    ).isRequired
};

const moduleMap = {
    hero: PRODUCT_PAGE.MODULES.PRODUCTS_HERO,
    orgCustomContent: PRODUCT_PAGE.MODULES.PRODUCTS_ORG_CUSTOM_CONTENT,
    userCustomContent: PRODUCT_PAGE.MODULES.PRODUCTS_USER_CUSTOM_CONTENT,
    products: PRODUCT_PAGE.MODULES.PRODUCT_LIST,
    contactForm: PRODUCT_PAGE.MODULES.CONTACT_FORM
};

const mapStateToProps = (state) => ({
    showOrgCustomContent: !_.isEmpty(state.theme_data.products_page.custom_content),
    showUserCustomContent: !_.isEmpty(state.profile.products_custom_content),
    moduleOrder: state.theme_data.products_page.modules &&
     _.flatten(_.pluck(state.theme_data.products_page.modules, 'module')).map(
         (moduleName) => moduleMap[moduleName]
     )
});

export default connectToJSContext(mapStateToProps)(ProductsPage);



// WEBPACK FOOTER //
// ./components/products_page/index.jsx